import * as React from 'react';

/** Material UI Packages. */
import { Typography, Box, TextField, Autocomplete, Popper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPopper = styled(Popper)({
    '& .MuiAutocomplete-listbox': {
        fontSize: '13px',
        overflowY: 'auto',
    },
    overflowY: 'auto',
});

/** Value holds the Object(id, name), but the label displays the NAME value. */
export function AutocompleteFieldObject({
    label,
    sx,
    value,
    onChange,
    onInputChange,
    name,
    options,
    AutocompleteStyle,
    labelStyle,
    disable,
    disableClearable,
    error,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '25px',
                ...sx,
            }}
        >
            <Typography
                sx={{
                    display: 'inline',
                    color: '#003a52',
                    fontSize: '13px',
                    fontWeight: 500,
                    width: '100px',
                    ...labelStyle,
                }}
            >
                {label}
            </Typography>
            <Autocomplete
                size="small"
                value={value || null}
                getOptionLabel={(option) => option.name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={onChange}
                onInputChange={onInputChange}
                options={options}
                name={name}
                slotProps={{
                    popper: {
                        component: StyledPopper,
                    },
                }}
                sx={{
                    '& .MuiInputBase-input': {
                        fontSize: '13px',
                        height: '12px',
                    },
                    ...AutocompleteStyle,
                }}
                renderInput={(params) => <TextField {...params} label="" name={name} error={error} />}
                renderOption={(props, option) => (
                    <li
                        {...props}
                        key={option.id}
                        style={{ margin: 0, padding: 0, paddingLeft: '5px', paddingBottom: '5px' }}
                    >
                        {option.name}
                    </li>
                )}
                disabled={!disable}
                disableClearable={disableClearable}
            />
        </Box>
    );
}
